import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import CreateConsultantModal from "components/Market/Consultants/CreateConsultantModal";

import * as marketReducer from "containers/Market/MarketReducer";

class CreateConsultantModalContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <CreateConsultantModal {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createConsultant: (consultant) => dispatch(marketReducer.createConsultant(consultant)),
    updateIsCreateConsultant: (isCreateConsultant) =>
      dispatch(marketReducer.updateIsCreateConsultant(isCreateConsultant))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    isCreateConsultant: marketReducer.getIsCreateConsultant(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(CreateConsultantModalContainer);
